import RegisterField, { FieldProps } from "../register-field";
import { DatePicker, DatePickerProps } from "@/components/inputs";
import { PickerValidDate } from "@mui/x-date-pickers";

export default function FormDatePicker<TDate extends PickerValidDate>({
    name,
    registerOptions,
    ...props
}: FieldProps<DatePickerProps<TDate>>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <DatePicker
            {...props}

            inputRef={field.ref}
            value={field.value}
            disabled={field.disabled}

            onChange={v => {
                field.handleChange(v);
                props.onChange && props.onChange(v);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}

            error={field.hasError}
            helperText={field.errorMessage}
        />}
    </RegisterField>
}